import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.943 23.057 13.886 16l7.057-7.057a1.332 1.332 0 1 0-1.885-1.885l-8 8a1.332 1.332 0 0 0 0 1.885l8 8a1.332 1.332 0 1 0 1.885-1.885v-.001Z" }));
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
